import { CobranzasAxios, COMPANY } from './config'

export const postNodos = async (data) => {
  const res = await CobranzasAxios.post(`/nodo/${COMPANY}`, data)
  return res.data
}

export const importNodos = async (data) => {
  const res = await CobranzasAxios.post(`/nodo/import/${COMPANY}`, data)
  return res.data
}

export const getNodos = async () => {
  const res = await CobranzasAxios.get(`/nodo/${COMPANY}`)
  return res.data
}

export const getContractsByNodos = async (nodoId) => {
  const res = await CobranzasAxios.get(`/nodo/contracts/${nodoId}`)
  return res.data
}

export const putNodos = async (data, id) => {
  const res = await CobranzasAxios.put(`/nodo/${id}`, data)
  return res.data
}
